export default "__VITE_ASSET__5fdWlOzR__"